import { render, staticRenderFns } from "./itemContent.vue?vue&type=template&id=f02ca2b2&scoped=true&"
import script from "./itemContent.vue?vue&type=script&lang=js&"
export * from "./itemContent.vue?vue&type=script&lang=js&"
import style0 from "./itemContent.vue?vue&type=style&index=0&id=f02ca2b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02ca2b2",
  null
  
)

export default component.exports